<div [formGroup]="parentForm">
	<mat-form-field class="example-chip-list">
	  <mat-label>FAVORITE LINES</mat-label>
	  <mat-chip-grid #chipList>
	    <mat-chip-row
	      *ngFor="let favorite of favoriteCounts"
	      [selectable]="selectable"
	      [removable]="removable"
	      (removed)="remove(favorite)">
	      {{ favorite.value }}<span *ngIf="favorite.count>1">({{ favorite.count }})</span>
	      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
	    </mat-chip-row>
	    <input
	      aria-label="FAVORITE LINES"
	      #favoriteInput
	      [formControl]="favoriteCtrl"
	      [matAutocomplete]="auto"
	      [matChipInputFor]="chipList"
	      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
	      [matChipInputAddOnBlur]="addOnBlur"
	      (focus)="loadFavorites()"
	      (matChipInputTokenEnd)="add($event)">
	  </mat-chip-grid>
	  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" (opened)="loadFavorites()">
	    <mat-option *ngFor="let favorite of filteredFavorites | async" [value]="favorite">
	      {{ favorite }}
	    </mat-option>
	  </mat-autocomplete>
	</mat-form-field>
</div>